<template>
  <v-menu
    offset-y
    :nudge-bottom="10"
    origin="center center"
    transition="scroll-y-transition"
    :max-width="300"
    :close-on-content-click="false"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        v-on="on"
        text
        small
        :class="selectedPortal && 'portalName' in selectedPortal ? '' : 'wave'"
      >
        <span
          v-if="selectedPortal && 'portalName' in selectedPortal"
        >{{ selectedPortal.portalName }}</span>

        <span v-else>Workspace</span>

        <v-icon small class="ml-2">expand_more</v-icon>
      </v-btn>
    </template>

    <v-container class="envronment-menu-arrow-top">
      <v-row class="d-flex flex-column pa-4">
        <v-combobox
          v-model="selectedEnvironment"
          class="mb-4"
          color="grey darken-3"
          :items="environments"
          label="Selecione o Ambiente"
          item-text="name"
          item-value="id"
          outlined
          dense
          hide-details
          clearable
          auto-select-first
          append-icon="expand_more"
          @input="handleChangeEnvironment"
          @click:clear="clearEnvironment"
        />

        <v-combobox
          v-model="selectedPortal"
          color="grey darken-3"
          :items="portals"
          label="Selecione o Portal"
          item-text="portalName"
          item-value="portalId"
          outlined
          dense
          hide-details
          :clearable="false"
          auto-select-first
          :disabled="!enablePortal"
          append-icon="expand_more"
          @input="handleChangePortal"
          @click:clear="clearPortal"
        />
      </v-row>
    </v-container>
  </v-menu>
</template>

<script>
import * as HANDLERS from '@/helpers/types/handlers';
import { INITIAL_SCHEMA } from '@/helpers/dev';

import { getPortals } from '@/services/dev';

export default {
  props: {
    environments: { type: Array, default: () => [], required: true }
  },

  data() {
    return {
      portals: [],
      enablePortal: false
    };
  },

  computed: {
    selectedEnvironment: {
      get() {
        return this.$store.getters['dev/getSelectedEnvironment'];
      },
      set(val) {
        this.$store.dispatch('dev/setSelectedEnvironment', val);
      }
    },

    selectedPortal: {
      get() {
        return this.$store.getters['dev/getSelectedPortal'];
      },
      set(val) {
        this.$store.dispatch('dev/setSelectedPortal', val);
      }
    },

    configLayout() {
      return this.$store.getters['dev/getConfigLayout'];
    },

    currentTemplate() {
      return this.$store.getters['dev/getCurrentTemplate'];
    }
  },

  methods: {
    clearEnvironment() {
      this.$store.dispatch('dev/setSelectedItem', {});
      this.$store.dispatch('dev/clearMenus', []);
      this.selectedEnvironment = null;
      this.selectedPortal = null;
      this.enablePortal = false;
      this.portals = [];
    },

    clearPortal() {
      this.$store.dispatch('dev/clearMenus', []);
      this.$store.dispatch('dev/setSelectedItem', {});
      this.selectedPortal = null;
      this.portals = [];
    },

    async handleChangeEnvironment() {
      if (!this.selectedEnvironment) return;

      try {
        const { data } = await getPortals(this.selectedEnvironment.id);

        this.portals = data;
      } catch (err) {
        this.portals = null;
      }

      this.$store.dispatch('dev/setSchema');
      this.$store.dispatch('dev/setSelectedPage', '');
      this.$store.dispatch('dev/setTypeOfPageEditing', '');
      this.$store.dispatch('dev/setInitialSchema', JSON.parse(JSON.stringify(INITIAL_SCHEMA)));

      this.$store.dispatch('dev/clearMenus', []);
      this.$store.dispatch('dev/setSelectedPortal', null);
      this.$store.dispatch('dev/setSelectedItem', {});
      this.enablePortal = true;
    },

    async handleChangePortal() {
      if (!this.selectedPortal) return;

      this.$store.dispatch('dev/setSelectedItem', {});

      if (this.currentTemplate === 'templateLayoutConfig') {
        await this.$store.dispatch('dev/getConfigLayout');

        for (let [key, value] of Object.entries(this.configLayout.theme)) {
          if (value !== '') {
            this.$vuetify.theme.themes.light[key] = value;
            this.$vuetify.theme.themes.dark[key] = value;
          }
        }
      }

      if (this.currentTemplate === 'templateMenu') {
        this.$store.dispatch('dev/getMenus');
      }

      if (this.currentTemplate === 'templatePage') {
        this.$store.dispatch('dev/getPages');
        this.$store.dispatch('dev/setSchema');
        this.$store.dispatch('dev/setSelectedPage', '');
        this.$store.dispatch('dev/setTypeOfPageEditing', '');
        this.$store.dispatch('dev/setInitialSchema', JSON.parse(JSON.stringify(INITIAL_SCHEMA)));
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.v-menu__content {
  overflow-y: initial;
  overflow-x: initial;
  contain: none;
  background: #fff;
}

.envronment-menu-arrow-top:before {
  bottom: 100%;
  left: 20%;
  margin-left: -6px;
  border: solid transparent;
  content: ' ';
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
  border-color: rgba(136, 183, 213, 0);
  border-width: 6px;
  border-bottom-color: #fff;
}
</style>
